<template>
  <div
    class="bb-lang-overlay"
    :class="{ mobile: !isPc }"
    v-show="isLanguage"
    @click.stop="closeModal()"
  >
    <div class="bb-lang-dialog" @click.stop="">
      <div class="bb-lang-head">
        <h2>{{ $t("account.changeLanguage") }}</h2>
        <button type="button" class="bb-lang-close" @click="closeModal()">×</button>
      </div>
      <div class="bb-lang-list">
        <button
          type="button"
          class="bb-lang-item"
          :class="{ on: langIndex == index }"
          v-for="(item, index) in langList"
          :key="index"
          @click="langChange(index)"
        >
          <span>{{ item.name }}</span>
          <svg v-if="langIndex == index" width="18" height="18" viewBox="0 0 24 24" fill="none">
            <path
              fill="currentColor"
              d="M9.55 17.65 4.9 13l1.4-1.4 3.25 3.25L17.7 6.7l1.4 1.4z"
            />
          </svg>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "Languages",
  data() {
    return {};
  },
  props: {
    isPc: {
      type: Boolean,
      default: false
    },
    isLanguage: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters(["langList", "langIndex"])
  },
  methods: {
    langChange(index) {
      let lang = this.langList[index].value;
      this.closeModal();
      this.$store.commit("SET_LANG", lang);
      this.$store.dispatch("listContents", lang == "zh" ? 1 : 2);
    },
    closeModal() {
      this.$emit("close");
    }
  }
};
</script>

<style scoped>
.bb-lang-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.55);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2100;
}
.bb-lang-dialog {
  width: 420px;
  max-width: calc(100vw - 32px);
  max-height: 80vh;
  display: flex;
  flex-direction: column;
  background: var(--bb-bg-card);
  color: var(--bb-text);
  border: 1px solid var(--bb-border);
  border-radius: 16px;
  box-shadow: var(--bb-shadow);
}
.bb-lang-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 20px 12px;
  flex-shrink: 0;
}
.bb-lang-head h2 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: var(--bb-text);
}
.bb-lang-close {
  width: 36px;
  height: 36px;
  border: 0;
  background: transparent;
  color: var(--bb-text);
  font-size: 28px;
  line-height: 1;
  cursor: pointer;
}
.bb-lang-list {
  padding: 4px 16px 20px;
  overflow: auto;
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.bb-lang-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  min-height: 44px;
  padding: 10px 14px;
  border: 1px solid transparent;
  border-radius: 10px;
  background: var(--bb-bg-input);
  color: var(--bb-text);
  font-size: 14px;
  text-align: left;
  cursor: pointer;
}
.bb-lang-item.on {
  border-color: var(--bb-brand);
  color: var(--bb-text);
}
.bb-lang-item.on svg {
  color: var(--bb-brand);
  flex-shrink: 0;
}
.bb-lang-overlay.mobile .bb-lang-dialog {
  width: calc(100vw - 32px);
}
</style>
